import { Controller } from "react-hook-form";
import { AddOnTextInput, Card, ErrorMessage, RadioInput, Typography } from "@/components/atoms";
import { extraTypeOptions } from "../../fixtures";
import { TollChargesFormData, FormRegister, FormErrors, FormControl } from "../types";

interface TollChargesCardProps {
  register: FormRegister<TollChargesFormData>;
  errors: FormErrors<TollChargesFormData>;
  control: FormControl<TollChargesFormData>;
}

export const TollChargesCard = ({ register, errors, control }: TollChargesCardProps) => {
  return (
    <Card as="fieldset">
      <Typography variant="title">Toll Charges</Typography>

      <Typography variant="action" className="mb-1 mt-3 block text-neutral-dark-gray">
        Toll Charges (Tolls incurred on the journey)
      </Typography>
      <div className="grid gap-2">
        <AddOnTextInput
          startAddOn="AUD $"
          placeholder="0.00"
          className="[&_[data-headlessui-state]]:flex-1"
          type="number"
          step="0.01"
          {...register("tollCharges", { valueAsNumber: true })}
        />
        <div className="flex">
          <Controller
            name="tollChargesType"
            control={control}
            render={({ field }) => (
              <>
                {extraTypeOptions.map((i) => (
                  <div className="mr-3 inline" key={i.value}>
                    <RadioInput
                      className="mt-2"
                      htmlFor={`toll-charges-${i.value}`}
                      label={i.name}
                      value={i.value}
                      onChange={({ target }) => field.onChange(target.value)}
                      checked={field.value === i.value}
                    />
                  </div>
                ))}
              </>
            )}
          />
        </div>
        <ErrorMessage errors={errors} name="tollCharges" />
      </div>
    </Card>
  );
};
